var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"item-1"}),_c('div',{staticClass:"item-2"}),_c('div',{staticClass:"item-3"}),_c('div',{staticClass:"item-4"}),_c('div',{staticClass:"item-5"})])])
}]

export { render, staticRenderFns }